//copyright itestra 2016
import { Component, ViewContainerRef } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import * as moment from "moment";

@Component({
    selector: "shell-app",
    template: ` <router-outlet></router-outlet> `,
})
export class ShellComponent {
    constructor(
        private vcr: ViewContainerRef,
        private toastr: ToastrService,
    ) {
        moment.locale("de");
        // this.toastr.setRootViewContainerRef(vcr)
    }
}
